import styled from 'styled-components';

export const Container = styled.div`
  width: 527px;
  padding: 4.5rem 3.8rem;
`;

export const WrapperTop = styled.div`
  margin-bottom: 2rem;
`;

export const Description = styled.span`
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
`;

export const ButtonsArea = styled.div`
  height: 100%;
  justify-content: space-between;
  display: flex;
  margin-top: 10%;
`;
